
import React, { useCallback, useEffect, useState } from 'react'
import Layout from '../../common/Layout'
import { dispatchMmvData, dispatchResetApiRequestQQ } from '../../store/actions/userActions';
import { useDispatch, useSelector } from 'react-redux';
import ReactSelect from 'react-select'
import { GetDataWithToken, PostDataWithToken } from '../../constants/ApiHelper';
import { FaCheck, FaPlus } from 'react-icons/fa';
import _ from 'lodash';
import { toast } from 'react-toastify';

const AddMmv = () => {
    const dispatch = useDispatch()
    const mmvData = useSelector(state => state?.root?.mmvData)
    const userDetails = useSelector(state => state?.root?.userDetails)
    const apiUrl = {
        IF: 'https://api.insurefast.in/api/v1/',
        // IF: 'https://test.insurefast.in/api/v1/',
        EC: 'https://api.expertcover.in/api/v3/',
        // EC: 'https://uatapi.expertcover.in/api/v3/',
    }

    const [vehicleType, setVehicleType] = useState('')
    const [errors, setErrors] = useState({})
    const [loading, setLoading] = useState(false)

    const [makeData, setMakeData] = useState([])
    console.log("makeData", makeData);

    const [modelData, setModelData] = useState([])
    const [varientData, setVarientData] = useState([])


    const [makeId, setMakeId] = useState('')
    const [modelId, setModelId] = useState('')
    const [insurerData, setInsurerData] = useState([])

    const [selectedMake, setSelectedMake] = useState(null)
    const [selectedModal, setSelectedModal] = useState(null)
    const [selectedVarient, setSelectedVarient] = useState(null)
    const [insurerVarintCodeObj, setInsurerVarintCodeObj] = useState({});
    console.log("insurerVarintCodeObj", insurerVarintCodeObj);

    const [addMake, setAddMake] = useState()
    const [addModel, setAddModel] = useState()
    const [addVariant, setAddVariant] = useState()

    const [addFuel, setAddFuel] = useState("")
    const [addCC, setAddCC] = useState("")
    const [addGVW, setAddGVW] = useState("")
    const [addSeats, setAddSeats] = useState("")
    const [addCapacity, setAddCapacity] = useState("")
    const [addWheels, setAddWheels] = useState("")
    const [subClass, setSubClass] = useState('')

    const [variant, setVarient] = useState()
    console.log("setVarient", variant);
    const [idData, setIdData] = useState()
    console.log("idData", idData);

    const handleSelectProduct = val => {
        setLoading(true);

        // Add query parameters correctly, removing any extra commas
        let data = new URLSearchParams({
            isMmvPanel: true,
            vehicleType: vehicleType, // Ensure this is passed without any extra commas or spaces
        }).toString();

        GetDataWithToken(val, `admin/getAllInsData?${data}`).then(res => {
            setLoading(false);
            if (res?.status === 'success') {
                setInsurerData(res?.data);
            } else {
                console.log('Insurer Data', res?.status);
            }
        });
    }

    const handleSelectVehicleType = val => {
        setSelectedVarient(null)
        setSelectedMake(null)
        setSelectedModal(null)
        setAddMake('')
        dispatchMmvData('makeId', '')
        dispatchMmvData('modelId', '')
        dispatchMmvData('variant', '')
        dispatchMmvData('make', '')
        dispatchMmvData('model', '')
        dispatchMmvData('varientId', '')
        setSelectedMake("")
        setSelectedModal("")
        setSelectedVarient("")
        setAddFuel("")
        setAddCC('')
        setAddCapacity('')
        setAddWheels('')
        setAddGVW('')
        setAddSeats("")

        const vehicleTypeClean = val?.trim();  // This ensures no trailing commas or spaces
        setVehicleType(vehicleTypeClean);
        dispatchMmvData('vehicleType', vehicleTypeClean);

        if (userDetails?.productOwner === 'EC') {
            dispatchMmvData('apiUrl', apiUrl?.EC);
        } else if (userDetails?.productOwner === 'IF') {
            dispatchMmvData('apiUrl', apiUrl?.IF);
        }
    };
    useEffect(() => {
        if (vehicleType && mmvData?.apiUrl) {
            handleSelectProduct(mmvData?.apiUrl);
            getMakeData()
        }
    }, [vehicleType, mmvData?.apiUrl]);

    const getMakeData = val => {
        setLoading(true)
        let makeObj = {
            vehicleType: mmvData?.vehicleType
        }
        PostDataWithToken(mmvData?.apiUrl, 'admin/getAllMakeData', makeObj).then(
            res => {
                let data = res?.data
                let i = 0
                let arr = []
                while (i < data?.length) {
                    let item = data[i]
                    arr.push({
                        label: item?.make,
                        value: item?.makeId
                    })
                    i++
                }
                setMakeData(arr)
                setLoading(false)
            }
        )
    }

    // Get Modal Data
    const getModelData = val => {
        setModelData([])
        setVarientData([])

        dispatchMmvData('makeId', val)
        setLoading(true)
        let makeObj = {
            vehicleType: mmvData?.vehicleType,
            makeId: val
        }
        PostDataWithToken(mmvData?.apiUrl, 'admin/getAllModelData', makeObj).then(
            res => {
                let data = res?.data
                let i = 0
                let arr = []
                while (i < data?.length) {
                    let item = data[i]
                    arr.push({
                        label: item?.model,
                        value: item?.modelId
                    })
                    i++
                }
                setModelData(arr)
                setLoading(false)
            }
        )
    }
    //Get Variant Data
    const getVariantData = val => {
        setLoading(true)
        dispatchMmvData('modelId', val)
        let makeObj = {
            vehicleType: mmvData?.vehicleType,
            makeId: makeId ? makeId : mmvData?.makeId,
            modelId: val
        }
        PostDataWithToken(mmvData?.apiUrl, 'admin/getAllVariantData', makeObj).then(
            res => {
                let data = res?.data
                setVarient(data)
                console.log();


                let i = 0
                let arr = []
                while (i < data?.length) {
                    let item = data[i]
                    arr.push({
                        label: item?.variant,
                        value: item?.variantId
                    })
                    i++
                }
                setVarientData(arr)
                setLoading(false)
            }
        )
    }

    const handleSelectMake = (val, selectedOption) => {
        setSelectedVarient(null)
        setSelectedModal(null)
        const id = makeData.find(item => item.value === val)
        dispatchMmvData("make", id?.label)
        setMakeId(val)
        setIdData('')
        setAddFuel("")
        setAddCC('')
        setAddCapacity('')
        setAddWheels('')
        setAddGVW('')
        setAddSeats("")

        setSelectedMake(selectedOption)
        dispatchMmvData('makeId', val)

    }

    const handleSelectModel = (val, selectedOption) => {
        const id = modelData.find(item => item.value === val)
        dispatchMmvData("model", id?.label)
        setModelId(val)
        setIdData('')
        setSelectedVarient(null)
        setSelectedModal(selectedOption)
        dispatchMmvData('modelId', val)
    }
    const handleSelectVarient = (val, selectedOption) => {

        const id = variant.find(item => item.variantId === val)
        dispatchMmvData("variant", id?.variant)
        setIdData(id)

        setIdData(id)
        setSelectedVarient(selectedOption)
        dispatchMmvData('varientId', val)
    }

    const [makeModal, setMakeModal] = useState(false)
    const [modelModal, setModelModal] = useState(false)
    const [varientModal, setVarientModal] = useState(false)
    const closeModal = () => {
        setMakeModal(false)
    }
    const closeModelModal = () => {
        setModelModal(false)
    }
    const closeVarientModal = () => {
        setVarientModal(false)
    }
    useEffect(() => {
        if (idData) {
            setAddSeats(idData.seats);
            setAddFuel(idData.fuelType);
            setAddCC(idData.cc);
            setAddCapacity(idData.carringCapacity);
            setAddGVW(idData.gvw);
            setAddWheels(idData.noOfWheels);
        }
     
    }, [idData]);


    const handleChangeMake = useCallback(
        _.debounce((value) => {
            console.log("make", value);
        }, 500),
        []
    );

    const handleAddMake = (e) => {
        dispatchMmvData('makeId', '')
        dispatchMmvData('modelId', '')
        dispatchMmvData('varientId', '')
        setSelectedMake("")
        setSelectedModal("")
        setSelectedVarient("")
        setAddFuel("")
        setAddCC('')
        setSubClass("")
        setAddCapacity('')
        setAddWheels('')
        setAddGVW('')
        setAddSeats("")
        setAddModel("")
        setAddVariant('');
        setAddMake(e.target.value);
        handleChangeMake(e.target.value);
    };
    const handleAddModel = (e) => {
        setAddModel(e.target.value);
        handleChangeMake(e.target.value);
    };
    const handleAddVarient = (e) => {
        setAddVariant(e.target.value);
        handleChangeMake(e.target.value);
    };
    const handleAddFuel = (e) => {
        dispatchMmvData('varientId', '')
        setAddFuel(e);
    };
    const handleAddCC = (e) => {
        dispatchMmvData('varientId', '')
        setAddCC(e.target.value);
        handleChangeMake(e.target.value);
    };
    const handleAddGVW = (e) => {
        dispatchMmvData('varientId', '')
        setAddGVW(e.target.value);
        handleChangeMake(e.target.value);
    };
    const handleAddCapacity = (e) => {
        dispatchMmvData('varientId', '')
        setAddCapacity(e.target.value);
        handleChangeMake(e.target.value);
    };
    const handleAddSeats = (e) => {
        dispatchMmvData('varientId', '')
        setAddSeats(e.target.value);
        handleChangeMake(e.target.value);
    };
    const handleAddWheels = (e) => {
        dispatchMmvData('varientId', '')
        setAddWheels(e.target.value);
        handleChangeMake(e.target.value);
    };
    const handleAddSubClass = (e) => {
        dispatchMmvData('varientId', '')
        setSubClass(e.target.value);
        handleChangeMake(e.target.value);
    };

    const handleAddMmv = () => {
        let addMmvObj = {
            vehicleType: mmvData?.vehicleType,
            make: addMake || mmvData?.make,
            makeId: mmvData?.makeId || "",
            model: addModel || mmvData?.model,
            modelId: mmvData?.modelId || "",
            variant: addVariant || mmvData?.variant,
            variantId: mmvData?.varientId || "",
            fuelType: addFuel || idData?.fuelType,
            seats: idData?.seats || addSeats,
            cc: addCC || idData?.seats,
            carringCapacity: addCapacity || idData?.carringCapacity,
            subClass:subClass || idData?.subClass ,
            gvw: addGVW || idData?.gvw,
            noOfWheels: addWheels || idData?.noOfWheels,
            insurerVarintCodeObj: insurerVarintCodeObj,
        }


        console.log('addMmvObj', addMmvObj);

        PostDataWithToken(mmvData?.apiUrl, "admin/getAddMmv", addMmvObj)
        .then(response => {
            console.log("response",response);
            
            if (response?.status === "success") {
                toast.success("MMV Add Successful");
            } else  {
                const errorMsg = errors?.[0]?.errorMessage || "mmvFullName already exists in the database";
                console.log("errorMsg", errorMsg);
                toast.error(errorMsg);
            }
        })
        .catch(error => {
            console.error("Error:", error);
            toast.error("Failed to add MMV");
        });
    }
    const handleInsChange = (e, key) => {
        const { value } = e.target;
        setInsurerVarintCodeObj((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    return (
        <div>
            <Layout>
                <div className='container-fluid py-4 dash_main'>
                    <div className='row'>
                        <div className='card mb-4'>
                            <div className='card-body pt-0 pb-2'>
                                <div className='row mt-2'>
                                    <div className='col-xl-4 col-lg-3 col-md-6 col-12'>
                                        <label>Vehicle Type</label>
                                        <div className='mb-3'>
                                            <select
                                                className='form-control'
                                                onChange={e => handleSelectVehicleType(e.target.value)}
                                                value={vehicleType}
                                                name='vehicleType'
                                                id='vehicleType'
                                            >
                                                <option value=''>Select Vehicle</option>
                                                <option value='2w'>Two Wheeler</option>
                                                <option value='4w'>Private Car</option>
                                                <option value='pcv'>Passenger Carrying Vehicle</option>
                                                <option value='gcv'>Goods Carrying Vehicle</option>
                                                <option value='misc'>Miscellaneous Vehicle</option>
                                            </select>
                                            {errors.vehicleType && (
                                                <div className='text-danger'>{errors.vehicleType}</div>
                                            )}
                                        </div>
                                    </div>

                                    <div className='col-xl-4 col-lg-4 col-md-6 col-12'>
                                        <div className='d-flex'>
                                            <div className='col-10'>
                                                <label>Make</label>
                                                <ReactSelect
                                                    options={makeData}
                                                    name='Make'
                                                    placeholder='Select make'
                                                    value={selectedMake}
                                                    onChange={e => {
                                                        handleSelectMake(e?.value)
                                                        getModelData(e?.value)
                                                    }}
                                                />

                                            </div>

                                            <div>
                                                <div
                                                    className='add-sec'
                                                    onClick={() => setMakeModal(!makeModal)}
                                                >
                                                    <FaPlus />
                                                </div>
                                            </div>

                                        </div>

                                        <div className='mt-2'>
                                            {makeModal && (
                                                <div className='d-flex align-center' style={{ width: "92%" }}>
                                                    <input
                                                        type='text'
                                                        placeholder='Enter Make Name'
                                                        className='form-control'
                                                        name='Make'
                                                        onChange={handleAddMake}
                                                    />
                                                </div>

                                            )}
                                            <div>
                                            </div>
                                        </div>

                                    </div>
                                    <div className='col-xl-4 col-lg-4 col-md-6 col-12'>
                                        <div className='d-flex'>
                                            <div className='col-10'>
                                                <label>Model</label>
                                                <ReactSelect
                                                    options={modelData}
                                                    name='Model'
                                                    placeholder='Select model'
                                                    value={selectedModal}
                                                    onChange={e => {
                                                        handleSelectModel(e?.value)
                                                        getVariantData(e?.value)
                                                    }}
                                                />

                                            </div>

                                            <div>
                                                <div
                                                    className='add-sec'
                                                    onClick={() => setModelModal(!modelModal)}
                                                >
                                                    <FaPlus />
                                                </div>
                                            </div>

                                        </div>

                                        <div className='mt-2'>
                                            {modelModal && (
                                                <div className='d-flex align-center' style={{ width: "92%" }}>
                                                    <input
                                                        type='text'
                                                        placeholder='Enter Model Name'
                                                        className='form-control'
                                                        name='Model'
                                                        value={addModel}
                                                        onChange={handleAddModel}
                                                    />

                                                </div>

                                            )}
                                            <div>
                                            </div>
                                        </div>

                                    </div>
                                    <div className='col-xl-4 col-lg-4 col-md-6 col-12'>
                                        <div className='d-flex'>
                                            <div className='col-10'>
                                                <label>Varient</label>
                                                <ReactSelect
                                                    options={varientData}
                                                    name='Varient'
                                                    placeholder='Select Varient'
                                                    value={selectedVarient}
                                                    onChange={e => handleSelectVarient(e?.value)}
                                                />

                                            </div>

                                            <div>
                                                <div
                                                    className='add-sec'
                                                    onClick={() => setVarientModal(!varientModal)}
                                                >
                                                    <FaPlus />
                                                </div>
                                                {/* <div className='hide'>Add New</div> */}
                                            </div>

                                        </div>

                                        <div className='mt-2'>
                                            {varientModal && (
                                                <div className='d-flex align-center' style={{ width: "92%" }}>
                                                    <input
                                                        type='text'
                                                        value={addVariant}
                                                        placeholder='Enter Varient Name'
                                                        className='form-control'
                                                        name='Varient'
                                                        onChange={handleAddVarient}
                                                    />

                                                </div>

                                            )}
                                            <div>

                                                {/* <div className='hide'>Add New</div> */}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-xl-2'>
                                        <div className='mb-3'>
                                            <label>Fuel</label>
                                            {/* <input
                                                type='text'
                                                defaultValue={idData?.fuelType}
                                                value={idData?.fuelType || addFuel}
                                                placeholder='Enter Fuel Type'
                                                className='form-control'
                                                name='Fuel'
                                                onChange={handleAddFuel}

                                            /> */}
                                            <select class="form-control"
                                                id="fuelSelect"
                                                name="fuelSelect"
                                               value={addFuel}
                                                onChange={e => handleAddFuel(e.target.value)}
                                            >
                                                <option value="">Select fuel</option>
                                                <option value="Petrol">Petrol</option>
                                                <option value="Diesel">Diesel</option>
                                                <option value="LPG">LPG</option>
                                                <option value="CNG">CNG</option>
                                                <option value="Electric">Electric</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className='col-xl-2'>
                                        <div className='mb-3'>
                                            <label>CC</label>
                                            <input
                                                type='text'
                                                value={addCC}
                                                placeholder='Enter CC'
                                                className='form-control'
                                                name='CC'
                                                onChange={handleAddCC}
                                            />
                                        </div>
                                    </div>
                                    <div className='col-xl-2'>
                                        <div className='mb-3'>
                                            <label>Seats</label>
                                            <input
                                                value={addSeats}
                                                type='text'
                                                placeholder='Enter Seats'
                                                className='form-control'
                                                name='Seats'
                                                onChange={handleAddSeats}
                                            />
                                        </div>
                                    </div>
                                    <div className='col-xl-2'>
                                        <div className='mb-3'>
                                            <label>GVW</label>
                                            <input
                                                type='text'
                                                value={addGVW}
                                                placeholder='Enter GVW'
                                                className='form-control'
                                                name='GVW'
                                                onChange={handleAddGVW}
                                            />
                                        </div>
                                    </div>
                                    <div className='col-xl-2'>
                                        <div className='mb-3'>
                                            <label>Carring Capacity</label>
                                            <input
                                                type='text'
                                                value={ addCapacity}
                                                placeholder='Enter Carring Capacity'
                                                className='form-control'
                                                name='Carring Capacity'
                                                onChange={handleAddCapacity}
                                            />
                                        </div>
                                    </div>
                                    <div className='col-xl-2'>
                                        <div className='mb-3'>
                                            <label>No Of Wheels</label>
                                            <input
                                                type='text'
                                                placeholder='Enter no Of wheels'
                                                value={addWheels}
                                                className='form-control'
                                                name='No Of Wheels'
                                                onChange={handleAddWheels}
                                            />
                                        </div>
                                    </div>
                                    <div className='col-xl-2'>
                                        <div className='mb-3'>
                                            <label>Sub Class</label>
                                            <input
                                                type='text'
                                                placeholder='Enter no Of wheels'
                                                value={subClass}
                                                className='form-control'
                                                name='sub class'
                                                onChange={handleAddSubClass}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    {insurerData?.map((item) => (
                                        <div key={item.id} className="mb-4 col-4">
                                            <div className="d-flex flex-column">
                                                <label className="text-sm text-capitalize font-medium text-gray-700 mb-1">
                                                    {item?.mappingName}
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder={`Enter ${item?.mappingName} Code`}
                                                    value={insurerVarintCodeObj[item?.mappingName] || ''}
                                                    onChange={(e) => handleInsChange(e, item?.mappingName)}
                                                />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <div className='col-xl-12 col-lg-3 col-md-6 col-12'>
                                    <label></label>
                                    <div className='mb-3 d-flex justify-content-end gap-3'>
                                        <button
                                            type='button'
                                            className='btn btn-sec'
                                            onClick={handleAddMmv}

                                        >
                                            {loading ? 'Loading...' : 'Submit'}
                                        </button>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </Layout>
        </div>
    )
}

export default AddMmv